// ResizeHandle.tsx
import React, { useRef } from "react";

interface ResizeHandleProps {
  onResize: (delta: number) => void;
}

const ResizeHandle: React.FC<ResizeHandleProps> = ({ onResize }) => {
  const startX = useRef(0);

  const handleMouseDown = (e: React.MouseEvent) => {
    startX.current = e.clientX;

    const handleMouseMove = (moveEvent: MouseEvent) => {
      const delta = moveEvent.clientX - startX.current;
      startX.current = moveEvent.clientX;
      onResize(delta);
    };

    const handleMouseUp = () => {
      window.removeEventListener("mousemove", handleMouseMove);
      window.removeEventListener("mouseup", handleMouseUp);
    };

    window.addEventListener("mousemove", handleMouseMove);
    window.addEventListener("mouseup", handleMouseUp);
  };

  return (
    <div
      style={{
        position: "absolute",
        top: 0,
        right: 0,
        width: "5px",
        cursor: "col-resize",
        height: "100%",
        zIndex: 10,
      }}
      onMouseDown={handleMouseDown}
    />
  );
};

export default ResizeHandle;
